import "core-js/modules/es6.array.index-of";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.map";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
export default function filterPost(_ref) {
  var post = _ref.post,
      locale = _ref.locale,
      category = _ref.category,
      tag = _ref.tag;
  var _post$frontmatter = post.frontmatter,
      _post$frontmatter$lan = _post$frontmatter.language,
      language = _post$frontmatter$lan === void 0 ? '' : _post$frontmatter$lan,
      _post$frontmatter$cat = _post$frontmatter.categories,
      categories = _post$frontmatter$cat === void 0 ? [] : _post$frontmatter$cat,
      _post$frontmatter$tag = _post$frontmatter.tags,
      tags = _post$frontmatter$tag === void 0 ? [] : _post$frontmatter$tag,
      path = _post$frontmatter.path;
  var lowerCategories = categories.map(function (c) {
    return c.toLowerCase();
  });
  var lowerTags = tags.map(function (c) {
    return c.toLowerCase();
  });
  var isLocaleMatch = locale ? locale === language : true;
  var isCategoryMatch = category ? lowerCategories.includes(category.toLowerCase()) : true;
  var isTagMatch = tag ? lowerTags.includes(tag.toLowerCase()) : true;
  var isFragment = path.indexOf('/fragments') > 0;

  if (isLocaleMatch && isCategoryMatch && isTagMatch && !isFragment) {
    return true;
  }

  return false;
}